import React from "react";

import { SidebarListContainer, SidebarList, SidebarCollapsibleListItem } from "../ReportsView";
import { toTitleCase } from "../../../utils/filters";

const XBARReportSidebar = ({ accordionId, reportType, sidebarData }) => {
  return (
    <SidebarListContainer>
      <div className="accordion" id={accordionId}>
        <SidebarList>
          {sidebarData.map((item) => {
            return (
              <SidebarCollapsibleListItem
                accordionId={accordionId}
                key={item.uid}
                subListItems={item.sections}
                title={toTitleCase(item.title)}
                uid={item.uid}
              />
            );
          })}
        </SidebarList>
      </div>
    </SidebarListContainer>
  );
};

export default XBARReportSidebar;
